var emailIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"16\" viewBox=\"0 0 20 16\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#B4975A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M.829 7v8h17.8V7m0-2.818V1H.83v3.182l8.9 5.09 8.9-5.09z\"/>\n</svg>";

export { emailIcon as default };
